import React from 'react';
import { sortByUrgencyIndication } from '../../../../pages/your-skills/your-skills.helpers';
import { GridItemLayout, GridLayout, kebabCase } from '@keplerco/core';
import { EntitySkillScoresCard } from '../../../../components/cards/entity-skill-scores-card/entity-skill-scores-card';
import { ISunburstModalLayoutProps } from './sunburst-modal.models';

export function SunburstModalLayout({ skillSubType, skillScoreTitle, skillScoreUseRAGColours, scoreComparison }: ISunburstModalLayoutProps): JSX.Element {
  return (
    <div className="modalContent">
      <header style={{ marginBottom: 30, textAlign: 'center' }}>
        <h2 id={kebabCase(`${skillSubType.name}-display-modal`)}>{skillSubType.name}</h2>
        <h3>The skill score breakdown to illustrate which skills to focus on first.</h3>
      </header>

      <GridLayout columnCount={3}>
        {skillSubType.skills
          .sort((a, b) => (!!a.urgencyIndication && !!b.urgencyIndication ? sortByUrgencyIndication(a.urgencyIndication, b.urgencyIndication) : (a.score?.percentage ?? 0) - (b.score?.percentage ?? 0)))
          .map(skill => {
            return (
              <GridItemLayout key={skill.slug}>
                <EntitySkillScoresCard name={skill.name} score={skill.score} urgencyIndication={skill.urgencyIndication} skillScoreTitle={skillScoreTitle} skillScoreUseRAGColours={skillScoreUseRAGColours} scoreComparison={scoreComparison} comparisonScore={skill.comparisonScore} />
              </GridItemLayout>
            );
          })}
      </GridLayout>
    </div>
  );
}
